export const I18N_PATH = 'new_team_drawer.add_team_success_modal';
export const I18N_BUTTON_PATH = `${I18N_PATH}.buttons`;

export const MESSAGE_KEY = {
  EMAIL_INVITE: 'email_invite',
  TEXT_INVITE: 'text_invite',
  EMAIL_PACKET_INVITE: 'email_packet_invite',
  TEXT_PACKET_INVITE: 'text_packet_invite',
};
